<app-page
  [title]="isPaymentRequiredOrder ? 'Payment for Order No. ' + (reorder$ | async)?.id : 'Authorization for Order No. ' + (reorder$ | async)?.id"
  [isLoading]="
    isPaymentRequiredOrder
      ? !hasStartedLoading || (isLoading$ | async) 
      : !hasStartedLoading || (isLoading$ | async) || (activeStep$ | async) === null || (activeStep$ | async) === undefined
  "
  [error]="errors$ | async"
  [centerTitle]="true"
>
  <div class="flex">
    <div class="flex-grow-1">
      <div *ngIf="!isPaymentRequiredOrder" class="grid grid-nogutter align-items-center mb-5">
        <p-progressBar
          class="col-12 sm:col-8 sm:col-offset-2"
          [value]="((((paymentOptionalCorrectedIndex$ | async) || 0) + 1) * 100) / ((stepCount$ | async) || 0)"
          [showValue]="false"
          data-cy="order-wizard-progress-bar"
        ></p-progressBar>
        <div class="hidden sm:inline-block col-1 p-0 p4 ml-3">
          {{ ((paymentOptionalCorrectedIndex$ | async) || 0) + 1 }}/{{ stepCount$ | async }}
        </div>
      </div>
      <div class="mb-4">
        <app-message severity="info" data-cy="order-wizard-shipping-message">
          <span *ngIf="isInsuranceChanged$ | async"> Your order requires insurance verification. </span>
          <span *ngIf="(isMissingPwoDocs$ | async) && (isShippingSoon$ | async)">
            Your order requires updated documentation.
          </span>
          <span *ngIf="(isMissingPwoDocs$ | async) && (isShippingSoon$ | async) === false">
            Your order requires updated documentation.
          </span>
          <span *ngIf="(isInsuranceChanged$ | async) || (isMissingPwoDocs$ | async)">
            Our team is working on your behalf to confirm.
          </span>
          <span>
            Estimated Ship Date for this order is
            {{ computedTargetShipDate$ | async | formatDate }}.
          </span>
          <span *ngIf="isShipmentDelayed$ | async"> Dates reflect insurance requirements.</span>
        </app-message>
      </div>

      <app-widget
        *ngIf="activeStep$ | async"
        [title]="!isPaymentRequiredOrder && (activeStep$ | async) ? ((activeIndex$ | async) || 0) + 1 + '. ' + (activeStep$ | async)?.title : ''"
        [noCard]="true"
        [noMargin]="true"
        data-cy="order-wizard-step-content"
      >
        <router-outlet></router-outlet>
      </app-widget>
    </div>
    <app-wizard-debug-info></app-wizard-debug-info>
  </div>
</app-page>
